import React, { memo } from 'react';
import { useBridgeState } from '@digitaz/bridge-sdk-client';
import Icon from '../Icon';
import Plus from '../../public/static/images/green-plus.svg';
import CloseWebview from '../../public/static/images/close-webview.svg';
import { ButtonLocation } from '../../types';
import { setButtonNewAdEvent } from '../../utils/pushDataLayerEvents';
import {
  WhiteHeaderWebviewBtn,
  WhiteHeaderContainer
} from '../WhiteHeader/styled';
import { StyledLogoIcon } from '../HamburgerMenu/styled';

export const HeaderLight = memo(() => {
  const { isWebView } = useBridgeState();

  return (
    <WhiteHeaderContainer
      className="white-header white-header--main"
      id="white-header"
    >
      <a data-stat="header-logo" href="/" tabIndex="-1">
        <Icon IconComponent={StyledLogoIcon} width={85} height={19} />
      </a>
      {isWebView ? (
        <WhiteHeaderWebviewBtn>
          <i>
            <Icon
              IconComponent={CloseWebview}
              width={15}
              height={15}
              indent={false}
              color={'#a9a39e'}
            />
          </i>
        </WhiteHeaderWebviewBtn>
      ) : (
        <a
          className="white-header__new-btn"
          href="/items/new"
          data-stat="header-new-btn"
          onClick={() => setButtonNewAdEvent(ButtonLocation.MobileHeader)}
        >
          <Icon IconComponent={Plus} width={30} height={30} indent={false} />
        </a>
      )}
    </WhiteHeaderContainer>
  );
});

HeaderLight.displayName = 'HeaderLight';
